// UnitFilters.jsx
import React from 'react';
import {
  Box,
  Typography,
  Tooltip,
  Fab,
} from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { useSearchParams } from 'react-router-dom';

import ExportConfig from '../../../../components/buttons/ExportConfig';
import DateRangePicker from '../../../../components/filters/DateRangePicker';
import ChipFilter from '../../../../components/filters/ChipFilter';
import styles from './UnitFilters.styles';

export default function UnitFilters({
  // ❌ removed: viewMode, setViewMode
  filters,
  setFilters,
  dateRange,
  setDateRange,
  nameOptions = [],
  operatorOptions = [],
  errorOptions = [], // kept in case you add an error ChipFilter later
  onAdd,
}) {
  const [searchParams, setSearchParams] = useSearchParams();

  const toggleFilter = (type, value) => {
    setFilters((prev) => {
      const current = prev[type] || [];
      const updated = current.includes(value)
        ? current.filter((x) => x !== value)
        : [...current, value];

      if (type === 'operator') {
        const params = new URLSearchParams();
        if (updated.length) params.set('operator', updated.join(','));
        else params.delete('operator');
        setSearchParams(params.toString());
      }

      return { ...prev, [type]: updated };
    });
  };

  const clearFilter = (type) => {
    setFilters((prev) => ({ ...prev, [type]: [] }));

    if (type === 'operator') {
      const params = new URLSearchParams(searchParams);
      params.delete('operator');
      setSearchParams(params.toString());
    }
  };

  return (
    <Box sx={styles.filterRow}>
      {/* Left filters */}
      <Box sx={styles.filterLeft}>
        <Typography sx={styles.label}>Filters:</Typography>

        <ChipFilter
          label="Unit"
          type="name"
          values={nameOptions}
          selectedValues={filters.name}
          onToggle={toggleFilter}
          onClear={clearFilter}
        />

        <ChipFilter
          label="Operator"
          type="operator"
          values={operatorOptions}
          selectedValues={filters.operator}
          onToggle={toggleFilter}
          onClear={clearFilter}
        />

        <DateRangePicker dateRange={dateRange} setDateRange={setDateRange} />
      </Box>

      {/* Right controls (export + add only) */}
      <Box sx={styles.rightControls}>
        <ExportConfig sx={styles.fabButton} />

        <Tooltip title="Create new unit" arrow>
          <Fab size="small" sx={styles.fabButton} onClick={onAdd}>
            <AddIcon fontSize="small" />
          </Fab>
        </Tooltip>
      </Box>
    </Box>
  );
}
